import { Avatar, Grid } from "@mui/material";
import Flex from "@/components/Flex";
import LabeledValue from "@/components/LabeledValue";
import Text from "@/components/Text";
import {
  CHART_COLORS,
  CHART_DIMENSIONS,
  CHART_TYPOGRAPHY,
} from "@/components/app/provider/patient/chart";
import { GROUP_THERAPIST_FIELD_LABEL } from "../group-visit-constant";
import { GroupTherapist } from "../group-visit-types";
import { getInitials } from "../group-visit-utils";

export type TherapistProfileProps = {
  therapist: GroupTherapist;
  /** Highlights the avatar for the primary assignment. */
  isPrimary?: boolean;
};

const AVATAR_SIZE = 32;

/**
 * Therapist identity plus their specialty, role, location and email.
 *
 * @author Rajkumar Rathod
 */
const TherapistProfile = ({ therapist, isPrimary }: TherapistProfileProps) => {
  return (
    <Flex gap={1.5} alignItems="flex-start">
      <Avatar
        sx={{
          width: AVATAR_SIZE,
          height: AVATAR_SIZE,
          fontSize: CHART_DIMENSIONS.iconSm,
          bgcolor: isPrimary
            ? CHART_COLORS.btnPrimaryBg
            : CHART_COLORS.badgeDefaultBg,
          color: isPrimary ? CHART_COLORS.surfaceWhite : CHART_COLORS.textDark,
        }}
      >
        {getInitials(therapist.name)}
      </Avatar>

      <Flex flexDirection="column" gap={1} flex={1} minWidth={0}>
        <Text
          {...CHART_TYPOGRAPHY.body4}
          fontWeight={CHART_TYPOGRAPHY.weight.medium}
          c={CHART_COLORS.textDarker}
        >
          {therapist.name}
        </Text>

        <Grid container spacing={1.5}>
          <Grid
            size={{
              xs: 12,
              sm: 6,
            }}
          >
            <LabeledValue
              label={GROUP_THERAPIST_FIELD_LABEL.specialty}
              value={therapist.specialty}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6,
            }}
          >
            <LabeledValue
              label={GROUP_THERAPIST_FIELD_LABEL.role}
              value={therapist.role}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6,
            }}
          >
            <LabeledValue
              label={GROUP_THERAPIST_FIELD_LABEL.location}
              value={therapist.location}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6,
            }}
          >
            <LabeledValue
              label={GROUP_THERAPIST_FIELD_LABEL.email}
              value={therapist.email}
            />
          </Grid>
        </Grid>
      </Flex>
    </Flex>
  );
};

export default TherapistProfile;
